import { render, staticRenderFns } from "./text-compare.vue?vue&type=template&id=3948fc6e&scoped=true"
import script from "./text-compare.vue?vue&type=script&lang=js"
export * from "./text-compare.vue?vue&type=script&lang=js"
import style0 from "./text-compare.vue?vue&type=style&index=0&id=3948fc6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3948fc6e",
  null
  
)

export default component.exports